import { CHIP_GREY } from './actionCardColors';

// The grey "N <things>" total chip pinned to the far right of a strip card's chips row, shared by
// the New / Booked / Attended / Started strips so the unscoped ("show all") state reads the same
// everywhere. Render it through `card.totalChip`; set `card.fadeEmphasis` while it is the active
// selection so the card headline + tone chips drop to FADED_OPACITY.
export const FADED_OPACITY = 0.45;

export const pluralize = (n, singular, plural) => (n === 1 ? singular : plural);

export const buildTotalChip = ({ text, tooltip, selected, onClick, testId = 'total-chip' }) => ({
    bucket: '__total',
    testId,
    text,
    type: 'info',
    showDot: false,
    pinRight: true,
    tooltip,
    onClick,
    selected: Boolean(selected),
    sx: {
        marginLeft: 'auto',
        // Global App.css `button { text-transform: capitalize !important }` would render
        // "62 New Leads" — keep the explicit opt-out.
        textTransform: 'none !important',
        color: CHIP_GREY.text,
        backgroundColor: CHIP_GREY.bg,
        fontWeight: selected ? 700 : 600,
    },
});
